export enum DeliveryStrategyType {
  AllItems = 0,
  ByWeek = 1,
  ByDeliveryDays = 2,
}
